import { render, staticRenderFns } from "./Backdrop.vue?vue&type=template&id=b154db5c&scoped=true&"
import script from "./Backdrop.vue?vue&type=script&lang=js&"
export * from "./Backdrop.vue?vue&type=script&lang=js&"
import style0 from "./Backdrop.vue?vue&type=style&index=0&id=b154db5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b154db5c",
  null
  
)

export default component.exports